import { t } from "app/utils";

const surveyItemTypes = [
  {
    value: "free_text",
    name: t("Text"),
    icon: "ios-chatbubble-outline",
    description: t("Open-ended response")
  },
  {
    value: "range",
    name: t("Scale"),
    icon: "ios-settings",
    description: t("Select within a range")
  },
  {
    value: "multi_choice_one",
    name: t("Multiple Choice"),
    icon: "ios-list-outline",
    description: t("Select a single option")
  },
  {
    value: "multi_choice_many",
    name: t("Multiple Choice"),
    icon: "ios-list-outline",
    description: t("Select multiple options")
  },
  {
    value: "rating",
    name: t("Rating"),
    icon: "ios-star-outline",
    description: t("1-5 Stars")
  }
];

export default surveyItemTypes;
